/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Grid, Link, Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { ExitDomain } from '@opengeoweb/theme';
import type { InfoDialogLinksProps } from '../../store/types';

const InfoDialogLinks: React.FC<InfoDialogLinksProps> = ({
  href,
  title,
}: InfoDialogLinksProps) => {
  return (
    <Grid
      container
      direction="column"
      key={href}
      spacing={0}
      style={{ paddingBottom: 20 }}
    >
      <Link href={href} rel="noopener" target="_blank">
        <Grid container direction="row" spacing={0.5}>
          {title ? (
            <Typography>{title}</Typography>
          ) : (
            <Typography>{t('Untitled')}</Typography>
          )}
          <ExitDomain />
        </Grid>
      </Link>
    </Grid>
  );
};

export default InfoDialogLinks;
